import React, { useState } from 'react'
import '../../../style.bundle.css'
import SigninForm from './form'
import { DoctorLogo } from '../../../assets'
import SAlert from '../../../components/Alert';
import { useDispatch } from 'react-redux';
import { userLogin } from '../../../redux/auth/action';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config';

function SignIn() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading,setIsLoading] = useState(false);

  const [form, setForm] = useState({
    email: '',
    password: ''
  });

  const [alert, setAlert] = useState({
    status: false,
    message: '',
    type: '',
  });

  const handleChange = (e) => {
    setForm({...form,[e.target.name]: e.target.value });
  }

  const handleSubmit = async () => {
    setIsLoading(true);
    try{
       const res = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
        }),
      });
      const data = await res.json();

      if (res.ok && (data.code === 200 || data.code === '200')){
          // Fetch user detail
          localStorage.setItem('access_token', data.data.token.original.access_token);

          dispatch(
            userLogin(
              data.data.token.original.access_token,
              data.data.permission.name_permission || '-',
              '',
              data.data.user,
              true
            )
          );
          setIsLoading(false)
          navigate('/dashboard');
      }else{
          if(data.code === 403 || data.code === '403'){
            setAlert({
              status: true,
              message: data.message || 'Your account is not active, please contact administrator!',
              type: 'danger',
              head: 'Warning!',
            });
            setIsLoading(false);
            return false;
          }else{
            setAlert({
              status: true,
              message: data.message || 'Email and Password is wrong!',
              type: 'danger',
              head: 'Error!'
            });
            setIsLoading(false);
            return false;
          }
      }
    }catch(error){
      setAlert({
        status: true,
        message: 'Email and Password is wrong!',
        type: 'danger',
        head: 'Error!'
      });
      setIsLoading(false)
    }

    setTimeout(function() {
      setAlert({
        status: false,
        message: '',
        type: '',
        head: ''
      });
    },2000)
  }

  return (
    <>
      <div className='d-flex flex-column flex-root'>
        <div className='d-flex flex-column flex-lg-row flex-column-fluid' style={{height:'100vh'}}>
          <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
              <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
                {alert.status && <SAlert type={alert.type} message={alert.message} head={alert.head} onClose={() => setAlert({ ...alert, status: false })} />}
                <div className='w-lg-500px p-10'>
                  <SigninForm 
                    form={form}
                    isLoading={loading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                  />
                </div>
              </div>
          </div>
          <div 
            className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
            style={{backgroundColor:'#844AFF'}}
          >
            <div className='d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100'>
              <img
                className='d-none d-lg-block mx-auto w-275px w-md-50 w-xl-300px mb-10 mb-lg-20'
                src={DoctorLogo}
                alt=''
              />
              <h1 className='d-none d-lg-block text-white fs-2qx fw-bolder text-center mb-7'>
                Fast, Efficient and Productive
              </h1>
              <div className='d-none d-lg-block text-white fs-base text-center'>
                In this kind of post, the blogger introduces a person they’ve interviewed
                and provides some background information about the interviewee and their
                work following this is a transcript of the interview.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignIn